import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { StEmptyCard } from './TimelineEmptyDay.styled'

const TimelineEmptyDay = () => {
  return (
    <StEmptyCard>
      <Span type='BodyLargeRegular'>Niets gepland vandaag</Span>
    </StEmptyCard>
  )
}

export { TimelineEmptyDay }
